import angular from 'angular';

// Adds a $timeout helper to $rootScope to be used in views to evalulate
// expressions after a given timeout. Useful for creating things after a delay:
//
// tab(heading='Map' select='$timeout("map=true")')
//   ov-comparables-map(
//     valuation='valuations_show.valuation'
//     address='valuations_show.valuation.address'
//     listings='[valuations_show_adjustments.comp.listing]'
//     ng-if='map'
//   )
module.exports = angular.module('common.services.timeout', [])
.run(($rootScope, $timeout) => {
  $rootScope.$timeout = function(expression, delay) {
    $timeout(() => { this.$eval(expression); }, delay);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/timeout.js
 **/